import { Component } from '@angular/core';
import { MdbModalRef } from 'mdb-angular-ui-kit/modal';
import { GenericCrudService } from 'src/app/services/crud/generic-crud.service';
import { CloneProfile } from 'src/app/models/interfaces.model';
import { ShowInfoSwal } from 'src/app/helpers/ShowInfoSwal';
import { catchError, throwError } from 'rxjs';
import { EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { environment } from 'src/app/environments/environments';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-modal-clone-profile',
  templateUrl: './modal-clone-profile.component.html',
  styleUrls: ['./modal-clone-profile.component.css']
})
export class ModalCloneProfileComponent {
  profileForm: FormGroup;
  @Output() OnGuardarClicked: EventEmitter<any> = new EventEmitter();
  loading: boolean = false;
  allUsers: Array<any> = [];
  selectedFromUser: string = "";
  selectedToUser: string = "";

  constructor(
    private fb: FormBuilder,
    public modalRef: MdbModalRef<ModalCloneProfileComponent>,
    private crudService: GenericCrudService<CloneProfile>) {
    this.profileForm = this.fb.group({
      selectedFromUser: ['', [Validators.required]],
      selectedToUser: ['', [Validators.required]],
    });
  }

  ngOnInit() {
    this.profileForm.patchValue({
      selectedFromUser: this.selectedFromUser,
      selectedToUser: this.selectedToUser,
      allUsers: this.allUsers,
    });
    this.profileForm.addControl('selectedFromUser', new FormControl());
    this.profileForm.addControl('selectedToUser', new FormControl());
  }

  onUserFromSelected(event: any): void {
    this.selectedFromUser = event;
  }

  onUserToSelected(event: any): void {
    this.selectedToUser = event;
  }

  async CloneProfile() {
    try {
      const body = new FormData();
      body.append('origin_user_id', this.selectedFromUser);
      body.append('destination_user_id', this.selectedToUser);
      
      const title = "Está a punto de clonar permisos, esto hará que los permisos del usuario origen se reemplacen por los del usuario destino, ¿Está seguro de realizar esta acción?";

      Swal.fire({
        title: title,
        icon: 'warning',
        width: 800,
        customClass: {
          popup: 'custom-swal-popup'
        },
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sí',
        cancelButtonText: 'Cancelar',
        allowOutsideClick: false
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            title: 'Procesando...',
            allowOutsideClick: false,
            showCancelButton: false,
            showCloseButton: false,
            showConfirmButton: false,
            willOpen: () => {
              Swal.showLoading();
              this.crudService.crud(body, environment.CloneProfile).toPromise().then(() => {
                Swal.fire({
                  icon: 'success',
                  title: "Se ha clonado correctamente el perfil!",
                  showConfirmButton: false,
                  timer: 500
                });
                this.OnGuardarClicked.emit(true);
                this.modalRef.close();
              }).catch((error) => {
                Swal.fire({
                  icon: 'error',
                  title: 'Error al clonar permisos',
                  text: error.message,
                  allowOutsideClick: false,
                });
              });
            }
          });
        }
      });
    } catch (error) {
      console.error('Error:', error);
      throw error;
    } finally {
      this.loading = false;
    }
  }
}
